import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Heading, Text } from '@frontend/design-system';
import { NoProvidersIllustration } from '../../../images';

interface Props {
  onSetUpClick: () => void;
}

export const OnboardingFlowInitiatorInline = ({ onSetUpClick }: Props) => {
  const { t } = useTranslation('schedule-onboarding');

  return (
    <section css={containerStyle}>
      <NoProvidersIllustration />
      <Heading level={3}>{t('Ready to get booked?')}</Heading>
      <Text textAlign='center' color='light'>
        {t('Set up your first appointment type in 3 easy steps')}
      </Text>
      <Button onClick={onSetUpClick}>{t('Set Up Now')}</Button>
    </section>
  );
};

const containerStyle = css({
  position: 'absolute',
  zIndex: theme.zIndex.low,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: theme.spacing(10),
  gap: theme.spacing(2),
  height: '100%',
  width: '100%',
  backgroundColor: theme.colors.neutral5,
});
